import { useRecoilState, useRecoilValue } from 'recoil';
import { confirmedHangingProtocolSelector, previousHangingProtocolState } from './state';
import type { HangingProtocol } from './useHangingProtocol';
import { useBaseViewerData } from 'domains/viewer/Viewer/StudyLoader/useStudies';
import { useCurrentCaseId } from 'hooks/useCurrentCase';
import { WithApolloContext } from 'modules/Apollo/types';

export type UsePreviousHangingProtocol = {
  previousHangingProtocol: Nullable<HangingProtocol>;
  savePreviousHangingProtocol: () => void;
};

export const usePreviousHangingProtocol = ({
  context,
}: WithApolloContext): UsePreviousHangingProtocol => {
  // Snapshot whatever is *currently active* for this case — not just the raw server match —
  // so "previous" reflects reality. A previously confirmed HP takes priority over the
  // server-matched HP here, mirroring the same non-preview priority chain useHangingProtocol uses
  // (confirmed ?? matched). Without this, cancelling a preview started after a
  // refresh would fall back to the server match instead of the confirmed override (VX-4531).
  const currentCaseSmid = useCurrentCaseId();
  const { hangingProtocol: matchedHangingProtocol } = useBaseViewerData({ context });
  const confirmedHangingProtocol = useRecoilValue(
    confirmedHangingProtocolSelector(currentCaseSmid)
  );
  const [previousHangingProtocol, setPreviousHangingProtocol] = useRecoilState(
    previousHangingProtocolState
  );
  const savePreviousHangingProtocol = () =>
    setPreviousHangingProtocol(confirmedHangingProtocol ?? matchedHangingProtocol);
  return {
    previousHangingProtocol,
    savePreviousHangingProtocol,
  };
};
